import { render, staticRenderFns } from "./ColaS.vue?vue&type=template&id=66e5f2f8"
import script from "./ColaS.vue?vue&type=script&lang=js"
export * from "./ColaS.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports